import { PropsWithChildren } from "react";
import { MainButton, useThemeParams } from "shared";

type hide = boolean;
type btnt = {
  onClick: () => void;
};
interface HideTgInterfaceProps {
  btn: hide | btnt;
}
const HideTgInterface = ({ btn }: HideTgInterfaceProps) => {
  const [, themeParams] = useThemeParams();
  const btnType = typeof btn;
  if (btnType === "boolean") {
  } else {
  }
  return (
    <MainButton
      theme={{
        color: themeParams.secondary_bg_color,
        textColor: themeParams.secondary_bg_color,
      }}
    >
      empty
    </MainButton>
  );
};
export const Page = ({ children }: PropsWithChildren) => {
  return <>{children}</>;
};
